import { render, staticRenderFns } from "./profile-contact-settings-widget.vue?vue&type=template&id=687c7285&"
import script from "./profile-contact-settings-widget.vue?vue&type=script&lang=js&"
export * from "./profile-contact-settings-widget.vue?vue&type=script&lang=js&"
import style0 from "./profile-contact-settings-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports